/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Open_Manager_Aria_LabelInputs */

const en_style_guide_open_manager_aria_label = /** @type {(inputs: Style_Guide_Open_Manager_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open Style Guide Manager`)
};

const fr_style_guide_open_manager_aria_label = /** @type {(inputs: Style_Guide_Open_Manager_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir le gestionnaire de guide de style`)
};

const de_style_guide_open_manager_aria_label = /** @type {(inputs: Style_Guide_Open_Manager_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open Style Guide Manager`)
};

const it_style_guide_open_manager_aria_label = /** @type {(inputs: Style_Guide_Open_Manager_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open Style Guide Manager`)
};

const ru_style_guide_open_manager_aria_label = /** @type {(inputs: Style_Guide_Open_Manager_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Менеджер открытых руководств по стилю`)
};

const es_style_guide_open_manager_aria_label = /** @type {(inputs: Style_Guide_Open_Manager_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrador de guías de estilo abierto`)
};

const zh_cn2_style_guide_open_manager_aria_label = /** @type {(inputs: Style_Guide_Open_Manager_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开放式样式指南管理器`)
};

const ja_style_guide_open_manager_aria_label = /** @type {(inputs: Style_Guide_Open_Manager_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スタイルガイドマネージャーを開く`)
};

const hi_style_guide_open_manager_aria_label = /** @type {(inputs: Style_Guide_Open_Manager_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ओपन स्टाइल गाइड मैनेजर`)
};

const pt_pt2_style_guide_open_manager_aria_label = /** @type {(inputs: Style_Guide_Open_Manager_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerenciador de Guia de Estilo Aberto`)
};

/**
* | output |
* | --- |
* | "Open Style Guide Manager" |
*
* @param {Style_Guide_Open_Manager_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_open_manager_aria_label = /** @type {((inputs?: Style_Guide_Open_Manager_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Open_Manager_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_open_manager_aria_label(inputs)
	if (locale === "de") return de_style_guide_open_manager_aria_label(inputs)
	if (locale === "it") return it_style_guide_open_manager_aria_label(inputs)
	if (locale === "ru") return ru_style_guide_open_manager_aria_label(inputs)
	if (locale === "es") return es_style_guide_open_manager_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_open_manager_aria_label(inputs)
	if (locale === "ja") return ja_style_guide_open_manager_aria_label(inputs)
	if (locale === "hi") return hi_style_guide_open_manager_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_open_manager_aria_label(inputs)
	return en_style_guide_open_manager_aria_label(inputs)
});